import { InjectionToken } from '@angular/core';
import { ColorMap } from './color-map';

export const COLORS = new InjectionToken<Partial<ColorMap>>('PAGE451_COLORS');
